/**
 * The customer's age, the one CdQ question the shared acquisition rules do not
 * already answer: the requested amount, the income, the pension and the
 * telephone are judged by exactly the same bounds as Prestito's, so CdQ uses
 * those rules as they are.
 */

/** An age is typed in whole years; three digits is already more than enough. */
export const cdqAgeInput = (raw: string) => raw.replace(/\D/g, '').slice(0, 3);

/** `null` when the typed text is not a whole number of years. */
export const cdqAgeToNumber = (display: string): number | null => {
  const digits = display.replace(/\D/g, '');
  return digits ? Number(digits) : null;
};

const CDQ_MIN_AGE = 18;
const CDQ_MAX_AGE = 100;

/**
 * The age the product accepts at all. Whether a pensioner is too old to
 * qualify is the product's policy, not the field's, so it is judged elsewhere.
 */
export const cdqAgeRule = (age: number | null) => {
  if (age === null) return "Inserisci l'età in anni interi";
  return age >= CDQ_MIN_AGE && age <= CDQ_MAX_AGE
    ? true
    : "L'età deve essere tra 18 e 100 anni";
};
